export default {
  name: 'Header',
  //---components
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      default: null
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    appendIcon: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    rules: {}
  },
  /**
   * @emit
   * lazy-change
   * error
   */
  //---data
  data () {
    return {
      currentData: null,
      defaultLazyTime: 2,
      flags: {
        isLazyLoader: false
      },
      isValid: true
    }
  },
  //---hooks
  watch: {
    value: {
      immediate: true,
      handler: function(val) {
        this.currentData = val;
      },
    }
  },
  //----methods
  methods: {
    changeData() {
      this.$emit('input', this.currentData);

      this.flags.isLazyLoader = false;

      clearTimeout(this.preChangeLoaderTimer);
      clearTimeout(this.preChangeTimer);

      this.preChangeLoaderTimer = setTimeout(() => {
        this.flags.isLazyLoader = true;
      }, 500);

      this.preChangeTimer = setTimeout(() => {
        this.flags.isLazyLoader = false;
        this.$emit('lazy-change', this.currentData)
      }, (this.defaultLazyTime * 1000 + 500))
    }
  }
}
